import { render, staticRenderFns } from "./addBox.vue?vue&type=template&id=274b4df5&scoped=true&"
import script from "./addBox.vue?vue&type=script&lang=js&"
export * from "./addBox.vue?vue&type=script&lang=js&"
import style0 from "./addBox.vue?vue&type=style&index=0&id=274b4df5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b4df5",
  null
  
)

export default component.exports